import { html } from 'rune-ts';

export class OnlinePopupStoreText {
  texts = {
    submit_form_title: ET('mps2::landing::popup_store::submit_form_title'),
    submit_form_description: ET('mps2::landing::popup_store::submit_form_description'),
    submit_form_creator: ET('mps2::landing::popup_store::submit_form_creator'),
    submit_form_is_creator: ET('mps2::landing::popup_store::submit_form_is_creator'),
    submit_form_is_creator_yes: ET('mps2::landing::popup_store::submit_form_is_creator_yes'),
    submit_form_is_creator_no: ET('mps2::landing::popup_store::submit_form_is_creator_no'),
    submit_form_domain: ET('mps2::landing::popup_store::submit_form_domain'),
    submit_form_company: ET('mps2::landing::popup_store::submit_form_company'),
    submit_form_manager: ET('mps2::landing::popup_store::submit_form_manager'),
    submit_form_manager_email: ET('mps2::landing::popup_store::submit_form_manager_email'),
    submit_form_manager_phone: ET('mps2::landing::popup_store::submit_form_manager_phone'),
    submit_form_sns: ET('mps2::landing::popup_store::submit_form_sns'),
    submit_form_file: ET('mps2::landing::popup_store::submit_form_file'),
    submit_form_other: ET('mps2::landing::popup_store::submit_form_other'),
    submit_form_guide: ET('mps2::landing::popup_store::submit_form_guide'),
    submit_form_agree: ET('mps2::landing::popup_store::submit_form_agree'),
    submit_form_agree_content: html.preventEscape(
      ET('mps2::landing::popup_store::submit_form_agree_content'),
    ),
    submit_form_button: ET('mps2::landing::popup_store::submit_form_button'),
    submit_form_creator_error: ET('mps2::landing::popup_store::submit_form_creator_error'),
    submit_form_email_error: ET('mps2::landing::popup_store::submit_form_email_error'),
    submit_form_phone_error: ET('mps2::landing::popup_store::submit_form_phone_error'),
    submit_success_modal: ET('mps2::landing::popup_store::submit_success_modal'),
    submit_fail_modal: ET('mps2::landing::popup_store::submit_fail_modal'),
  } as const;

  mo_texts = {
    submit_form_title: ET('mps2::landing::popup_store::submit_form_title'),
    submit_form_description: ET('mps2::landing::popup_store::submit_form_description'),
    submit_form_creator: ET('mps2::landing::popup_store::mo_submit_form_creator'),
    submit_form_is_creator: ET('mps2::landing::popup_store::mo_submit_form_is_creator'),
    submit_form_is_creator_yes: ET('mps2::landing::popup_store::submit_form_is_creator_yes'),
    submit_form_is_creator_no: ET('mps2::landing::popup_store::submit_form_is_creator_no'),
    submit_form_domain: ET('mps2::landing::popup_store::mo_submit_form_domain'),
    submit_form_company: ET('mps2::landing::popup_store::mo_submit_form_company'),
    submit_form_manager: ET('mps2::landing::popup_store::mo_submit_form_manager'),
    submit_form_manager_email: ET('mps2::landing::popup_store::mo_submit_form_manager_email'),
    submit_form_manager_phone: ET('mps2::landing::popup_store::mo_submit_form_manager_phone'),
    submit_form_sns: ET('mps2::landing::popup_store::mo_submit_form_sns'),
    submit_form_file: ET('mps2::landing::popup_store::mo_submit_form_file'),
    submit_form_other: ET('mps2::landing::popup_store::mo_submit_form_other'),
    submit_form_guide: ET('mps2::landing::popup_store::submit_form_guide'),
    submit_form_agree: ET('mps2::landing::popup_store::submit_form_agree'),
    submit_form_agree_content: html.preventEscape(
      ET('mps2::landing::popup_store::submit_form_agree_content'),
    ),
    submit_form_button: ET('mps2::landing::popup_store::mo_submit_form_button'),
    submit_form_creator_error: ET('mps2::landing::popup_store::submit_form_creator_error'),
    submit_form_email_error: ET('mps2::landing::popup_store::submit_form_email_error'),
    submit_form_phone_error: ET('mps2::landing::popup_store::submit_form_phone_error'),
    submit_success_modal: ET('mps2::landing::popup_store::submit_success_modal'),
    submit_fail_modal: ET('mps2::landing::popup_store::submit_fail_modal'),
  } as const;

  getTexts = (is_mobile: boolean) => {
    return is_mobile ? this.mo_texts : this.texts;
  };
}
